<template>
  <div v-show="isShow" class="custom-mark-title-dialog">
    <button @click="handleClose" class="close-btn">
      <img src="../../../../../assets/images/icon/close.png" alt="" />
    </button>
    <p class="title">自定义标记</p>
    <div class="input-wrap">
      <el-input
        class="mark-title-input"
        type="text"
        placeholder="请填写标记内容"
        v-model.trim="text"
        maxlength="10"
        show-word-limit
      >
      </el-input>
      <button
        v-preventReClick
        @click="handleSave"
        class="save-btn"
        :class="{
          'save-btn__active': text.length,
        }"
      >
        保存
      </button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      text: "",
      isShow: false,
    };
  },
  methods: {
    handleClose() {
      this.isShow = false;
      this.text = "";
    },
    handleShow() {
      this.isShow = true;
    },
    handleSave() {
      if (this.text.length) {
        this.$emit("save", this.text);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.custom-mark-title-dialog {
  --custom-mark-title-bg: var(--mg-bg-elevated, var(--surface-overlay, #ffffff));
  --custom-mark-title-text: var(--mg-text-primary, var(--text-primary, #0d1400));
  --custom-mark-title-muted: var(--mg-text-muted, var(--text-muted, #c9cdd4));
  --custom-mark-title-border: var(--mg-border-subtle, var(--border-subtle, #f2f3f5));
  --custom-mark-title-control-bg: var(--mg-control-bg, var(--input-bg, #ffffff));
  --custom-mark-title-disabled-text: var(--mg-disabled-text, var(--disabled-text, #c9cdd4));
  --custom-mark-title-action-text: var(--mg-text-inverse, #ffffff);

  width: 284px;
  height: 62px;
  background: var(--custom-mark-title-bg);
  border-radius: 6px;
  border: 1px solid var(--custom-mark-title-border);
  position: relative;
  .close-btn {
    position: absolute;
    top: 4px;
    right: 4px;
    width: 20px;
    height: 20px;
  }
  .title {
    font-weight: 400;
    font-size: 12px;
    color: var(--custom-mark-title-text);
    line-height: 17px;
    padding: 8px 0 3px 8px;
  }
  .input-wrap {
    display: flex;
    align-items: center;
  }
  .mark-title-input {
    margin-right: 5px;
    width: 209px;
    margin-left: 6px;
  }
  ::v-deep .el-input__inner {
    border-radius: 6px;
    border: 1px solid var(--custom-mark-title-border);
    background: var(--custom-mark-title-control-bg);
    color: var(--custom-mark-title-text);
    height: 28px;
    padding: 0 4px;
  }
  ::v-deep .el-input__inner::placeholder {
    font-size: 12px;
    color: var(--custom-mark-title-muted);
  }
  ::v-deep .el-input__count {
    font-size: 12px;
    color: var(--custom-mark-title-muted);
  }
  ::v-deep .el-input__count-inner {
    background: var(--custom-mark-title-control-bg);
    color: var(--custom-mark-title-muted);
  }
  .save-btn {
    width: 54px;
    height: 28px;
    background: var(--custom-mark-title-control-bg);
    border-radius: 6px;
    border: 1px solid var(--custom-mark-title-border);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    color: var(--custom-mark-title-disabled-text);
    line-height: 1;
  }
  .save-btn__active {
    background: linear-gradient(132deg, #00eb81 0%, #00c89d 100%);
    border: none;
    color: var(--custom-mark-title-action-text);
    font-weight: 500;
  }
}
</style>

<style lang="scss">
html.dark .custom-mark-title-dialog,
html.theme-dark .custom-mark-title-dialog,
html[data-theme="dark"] .custom-mark-title-dialog,
#app.dark .custom-mark-title-dialog,
#app.theme-dark .custom-mark-title-dialog {
  --custom-mark-title-bg: var(--mg-bg-elevated, var(--card-bg, #17243a));
  --custom-mark-title-text: var(--mg-text-primary, var(--text-primary, #f1f5f9));
  --custom-mark-title-muted: var(--mg-text-muted, var(--text-muted, #94a3b8));
  --custom-mark-title-border: var(--mg-border-subtle, var(--border-subtle, rgba(255, 255, 255, 0.1)));
  --custom-mark-title-control-bg: var(--mg-control-bg, var(--input-bg, #1e293b));
  --custom-mark-title-disabled-text: var(--mg-disabled-text, var(--disabled-text, #cbd5e1));
  --custom-mark-title-action-text: var(--mg-text-inverse, #ffffff);
}
</style>
